import React, { useState } from 'react';
import { Row, Button, Col, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

import { GridConsultas } from './gridConsultas';
import { FormConsulta } from './formConsulta';
import lupaButtonNewConsult from '../../../../assets/icons/lupaButtonNewConsult.svg';
import iconBack from '../../../../assets/icons/iconBack.svg';

import * as S from '../styles';
import { ModalExclusao } from './modalExclusao';

export default function ConsultForm() {
  const [editConsult, setEditConsult] = useState();

  const [consulta, setConsulta] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [inputBusca, setInputBusca] = useState('');
  const [reloadGrid, setReloadGrid] = useState(false);

  const handleInputBusca = e => {
    setInputBusca(e.target.value);
  };

  const handleNewConsult = () => {
    if (editConsult) {
      return setEditConsult();
    }
    return setEditConsult({});
  };

  return (
    <>
      <Row style={{ width: '100%' }}>
        <ModalExclusao
          isModalVisible={isModalVisible}
          setIsModalVisible={setIsModalVisible}
          consulta={consulta}
          setReloadGrid={setReloadGrid}
          reloadGrid={reloadGrid}
        />
        <S.StyledCol span={24}>
          <h2>Consultas</h2>
          <Button
            style={{
              paddingLeft: '8px',
              height: '45px',
              fontWeight: 'bold',
              width: '150px',
              fontSize: '16px',
            }}
            onClick={() => handleNewConsult()}
          >
            <img
              src={editConsult ? iconBack : lupaButtonNewConsult}
              alt="newUser"
            />
            {editConsult ? 'Voltar ' : 'Nova Consulta'}
          </Button>
        </S.StyledCol>
      </Row>
      <Row
        justify="center"
        id="row"
        style={{
          width: '100%',
          marginTop: '28px',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <Col
          span={editConsult ? 12 : 24}
          style={{
            paddingRight: editConsult ? 24 : 0,
          }}
        >
          <Col
            style={{
              background: '#fff',
              borderRadius: '2px',
              padding: '24px 24px 0 24px',
              height: '680px',
            }}
          >
            <Row
              id="fixe"
              style={{
                background: '#fff',
                zIndex: '1',
              }}
              span={24}
            >
              <Input
                onChange={handleInputBusca}
                placeholder="Busca"
                span={12}
                style={{
                  background: '#F2F2F2',
                  border: 'none',
                  height: '48px',
                }}
                prefix={<SearchOutlined style={{ color: '#24A95D' }} />}
              />
              <Row
                span={24}
                style={{
                  position: 'relative',
                  width: '100%',
                  background: '#fff',
                  zIndex: '1',
                }}
              >
                <S.RowTitle
                  span={24}
                  style={{
                    width: '100%',
                    background: '#fff',
                    borderBottom: '2px solid #CACACA',
                    marginBottom: '3px',
                    color: '#001F2A',
                    fontSize: '12px',
                  }}
                >
                  <S.StyledColTitle span={6}>Nome</S.StyledColTitle>
                  <S.StyledColTitle span={6}>Fornecedor</S.StyledColTitle>
                  <S.StyledColTitle span={6}>Editar</S.StyledColTitle>
                  <S.StyledColTitle span={5}>Excluir</S.StyledColTitle>
                  <S.StyledColTitle span={1} />
                </S.RowTitle>
              </Row>
            </Row>
            <Col
              justify="center"
              id="col"
              span={24}
              style={{
                borderRadius: '2px',
                maxHeight: '455px',
                overflow: 'auto',
                background: '#fff',
                marginTop: '0',
              }}
            >
              <GridConsultas
                inputBusca={inputBusca}
                setEditConsult={setEditConsult}
                setConsulta={setConsulta}
                setIsModalVisible={setIsModalVisible}
                isModalVisible={isModalVisible}
                reloadGrid={reloadGrid}
              />
            </Col>
          </Col>
        </Col>
        <Col span={editConsult ? 12 : 0} style={{ background: '#fff' }}>
          <Col
            id="white"
            style={{
              background: '#fff',
              borderRadius: '2px',
              height: '680px',
              overflow: 'auto',
              marginRight: '5px',
            }}
          >
            {editConsult && (
              <FormConsulta
                setEditConsult={setEditConsult}
                editConsult={editConsult}
                setReloadGrid={setReloadGrid}
                reloadGrid={reloadGrid}
              />
            )}
          </Col>
        </Col>
      </Row>
    </>
  );
}
